import type { ReactNode } from 'react';

export interface TabItem {
  key: string;
  title: ReactNode;
  permission?: string; // optional; filtered by the caller if needed
}

interface TabsProps {
  tabs: TabItem[];
  active: string;
  onChange: (key: string) => void;
  className?: string;
  // "underline" = finkit-tabs (green underline active, the legacy default);
  // "pills" = green pill rail.
  variant?: 'underline' | 'pills';
  // Stretch tabs to full width with equal columns (legacy nav-justified).
  justified?: boolean;
}

// Shared tab strip. Content is rendered by the caller based on `active`.
// Uses the legacy finkit-tabs styling so the active tab is themed consistently.
export function Tabs({ tabs, active, onChange, className, variant = 'underline', justified = false }: TabsProps) {
  const wrapperClass = variant === 'pills' ? 'rd-finkit-tabs' : 'finkit-tabs';
  return (
    <div className={`${wrapperClass}${className ? ` ${className}` : ''}`}>
      <ul className={`nav nav-pills${justified ? ' nav-justified' : ''}`} role="tablist">
        {tabs.map((t) => (
          <li className="nav-item" key={t.key} role="presentation">
            <button
              type="button"
              className={`nav-link${active === t.key ? ' active' : ''}`}
              onClick={() => onChange(t.key)}
            >
              {t.title}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
